export const UPLOAD_IMAGE_TEXT = "Please upload images to start the inspection of the bicycle and get the price"
export const CONTINUE_TO_INSPECTION_TEXT = "Please continue to start the inspection of the bicycle"